import api from '../api';

export const adminAuditApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllAdmins: builder.query({
      query: ({ page, size }) => ({
        url: '/api/tenant/tenants',
        method: 'GET',
        params: { page, size }
      }),
      providesTags: ['GetAllAdmins']
    }),
    createAdmin: builder.mutation({
      query: ({ body }) => ({
        url: '/api/tenant/create',
        method: 'POST',
        body
      })
    }),
    chechkEmail: builder.mutation({
      query: ({ emailId }) => ({
        url: '/api/tenant/validate/tenant/email',
        method: 'POST',
        params: { emailId }
      })
    }),
    updateTenantProfile: builder.mutation({
      query: ({ userId, body }) => ({
        url: '/api/tenant/update/tenantProfile',
        method: 'PUT',
        params: { userId },
        body
      }),
      invalidatesTags: ['GetAllAdmins']
    }),
    deleteTenant: builder.mutation({
      query: userId => ({
        url: '/api/tenant/delete/tenantProfile',
        method: 'DELETE',
        params: { userId }
      }),
      invalidatesTags: ['GetAllAdmins']
    })
  })
});

export const {
  useLazyGetAllAdminsQuery,
  useCreateAdminMutation,
  useChechkEmailMutation,
  useDeleteTenantMutation,
  useUpdateTenantProfileMutation
} = adminAuditApi;
